import { FC } from 'react';

import rdbmsTable from 'assets/images/studio/data-source/rdbmsTable.svg';
import cn from 'utils/cn';

interface IRDBMSTableIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
}

const RDBMSTableIcon: FC<IRDBMSTableIconProps> = ({ ...rest }) => {
  return (
    <img
      {...rest}
      alt="rdbms table icon"
      data-testid="rdbms-table-icon"
      src={rdbmsTable}
      className={cn('tw:h-[16px] tw:w-[16px]', rest?.className)}
    />
  );
};

export default RDBMSTableIcon;
